import React, { useContext, useMemo } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { Row, Card } from 'react-bootstrap'
import { DesignContext } from 'contexts/DesignContext'
import HeaderControl, { headerControlTester } from './Header'
import BodyControl, { bodyControlTester } from './Body'
import FooterControl, { footerControlTester } from './Footer'
import { materialRenderers, materialCells } from '@jsonforms/material-renderers'
import { JsonForms } from '@jsonforms/react'
import { Formik } from 'formik'
import { checkError } from 'designer/component/validation'
import objectPath from 'object-path'

const WidgetControl = ({ config, schema, uischema }) => {
  const renderers = useMemo(() => {
    let { elements } = uischema
    let layout = objectPath.get(elements, [0, 'key'])
    let renderers = [...materialRenderers]
    if (layout === 'header') {
      return (renderers = [
        ...renderers,
        { tester: headerControlTester, renderer: HeaderControl },
      ])
    }
    if (layout === 'body') {
      return (renderers = [
        ...renderers,
        { tester: bodyControlTester, renderer: BodyControl },
      ])
    }
    if (layout === 'footer') {
      return (renderers = [
        ...renderers,
        { tester: footerControlTester, renderer: FooterControl },
      ])
    }
  }, [uischema?.layout])

  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext

  const initialValues = {}
  const validate = (values) => {
    let errors = checkError(jsonForm, values)
    return errors
  }

  return (
    <Card
      className={`${!uischema.cardColor && `border-${uischema.variant}`}`}
      style={{
        border: `1px solid ${uischema.cardColor}`,
        margin: 0,
        boxShadow: uischema.isShowBoxShadow ? '' : 'unset',
      }}
    >
      {uischema.isShowTitle && (
        <Card.Header
          className={`${!uischema.cardColor && `bg-${uischema.variant}`}`}
          style={{ backgroundColor: uischema.cardColor }}
        >
          <Card.Title className="m-0" style={{ color: uischema.textColor }}>
            {uischema.title}
          </Card.Title>
        </Card.Header>
      )}
      <Card.Body className="p-0">
        <Formik initialValues={initialValues} validate={validate}>
          <JsonForms
            schema={schema}
            uischema={uischema}
            config={{
              ...config,
              droppableId: uischema.key,
            }}
            renderers={renderers}
            cells={materialCells}
          />
        </Formik>
      </Card.Body>
    </Card>
  )
}

export const widgetControlTester = rankWith(3, scopeEndsWith('layout'))

export default withJsonFormsControlProps(WidgetControl)
